function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n      ", "\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
} // (C) Copyright 2017-2018 Hewlett Packard Enterprise Development LP


import { css } from 'styled-components';

var isObject = function isObject(item) {
  return item && typeof item === 'object' && !Array.isArray(item);
};

var deepFreeze = function deepFreeze(obj) {
  Object.keys(obj).forEach(function (key) {
    return key && isObject(obj[key]) && Object.freeze(obj[key]);
  });
  return Object.freeze(obj);
};

var workSansPath = 'https://fonts.gstatic.com/s/worksans/v2';
export var v1 = deepFreeze({
  global: {
    colors: {
      background: '#ffffff',
      brand: '#8C50FF',
      control: {
        dark: '#8C69FF',
        light: '#8C50FF'
      },
      focus: '#99d5ef',
      'neutral-1': '#5d0cfb',
      'neutral-2': '#7026ff',
      'neutral-3': '#767676',
      'accent-1': '#c3a4fe',
      'accent-2': '#a577ff',
      'status-critical': '#FF856B',
      'status-warning': '#FFB86B',
      'status-ok': '#4EB976',
      'status-unknown': '#a8a8a8',
      'status-disabled': '#a8a8a8',
      'dark-1': '#000001',
      'dark-2': '#333333',
      'dark-3': '#444444',
      'dark-4': '#555555',
      'dark-6': '#666666',
      'light-1': '#f5f5f5'
    },
    control: {
      border: {
        width: '1px',
        radius: '0px',
        color: 'border'
      }
    },
    font: {
      family: "'Work Sans', Arial, sans-serif",
      face: "\n        @font-face {\n          font-family: 'Work Sans';\n          src:\n            local('Work Sans'),\n            local('WorkSans-Regular'),\n            url(\"" + workSansPath + "//ElUAY9q6T0Ayx4zWzW63VJBw1xU1rKptJj_0jans920.woff2\") format('woff2');\n        }\n      "
    }
  },
  anchor: {
    color: 'control'
  },
  button: {
    extend: css(_templateObject(), function (props) {
      return !props.plain && "\n        font-weight: 600;\n        border-radius: 5px;\n        padding: 6px 22px;\n      ";
    })
  }
});